import HRLayout from "../../hr/HRLayout";
import useHRCopy from "../../hr/i18n/useHRCopy";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

export default function IsverenHizmetlerim() {
  const t = useHRCopy().employer;
  const [service, setService] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState({ type: false, text: "" });
  const [failureMessage, setFailureMessage] = useState({ type: false, text: "" });
  const [errors, setErrors] = useState({});
  const location = useLocation();

  // Option values are the canonical service names shared by both languages,
  // so a ?service= link and the API payload stay the same whatever the UI shows.
  const serviceValues = t.services.map((s) => s.value);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const preselected = query.get("service");
    if (preselected && serviceValues.includes(preselected.trim())) {
      setService(preselected.trim());
    } else {
      setService("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (failureMessage.text) {
      const timer = setTimeout(() => {
        setFailureMessage({ type: false, text: "" });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [failureMessage]);

  useEffect(() => {
    if (successMessage.text) {
      const timer = setTimeout(() => {
        setSuccessMessage({ type: false, text: "" });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const validateFields = () => {
    const newErrors = {};
    if (!service) newErrors.service = t.errors.service;
    if (!message.trim()) newErrors.message = t.errors.message;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_URL_EMPLOYER}/employer`, {
        service: service,
        message: message
        }, {
          headers: { "Content-Type": "application/json" }
      });

      setService("");
      setMessage("");
      setSuccessMessage({ type: true, text: t.success });
    } catch (error) {
      console.error("Submit error:", error);
      setFailureMessage({ type: true, text: t.failure });
    } finally {
      setLoading(false);
    }
  };

  return (
    <HRLayout>
      <section className="max-w-3xl mx-auto py-12 px-6 w-full">
        <div className="w-full bg-white rounded-sm border border-line p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-ink mb-2 text-center tracking-[-0.02em]">{t.title}</h1>
          <p className="text-steel text-center mb-8">{t.lede}</p>

          <form onSubmit={handleSubmit} className="space-y-7">
            <div>
              <label htmlFor="employer-service" className="block text-sm font-semibold text-gray-700 mb-1">{t.serviceLabel} <span className="text-red-500">*</span></label>
              <select
                id="employer-service"
                value={service}
                onChange={(e) => setService(e.target.value)}
                className={`w-full border border-line rounded-sm px-4 py-2 focus:ring-2 focus:ring-royal/40 focus:border-royal outline-none transition bg-white font-medium text-ink ${errors.service ? 'border-red-400' : ''}`}
              >
                <option value="">{t.servicePlaceholder}</option>
                {t.services.map((s) => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
              {errors.service && <p className="text-red-500 text-xs mt-1 font-medium">{errors.service}</p>}
            </div>

            <div>
              <label htmlFor="employer-message" className="block text-sm font-semibold text-gray-700 mb-1">{t.messageLabel} <span className="text-red-500">*</span></label>
              <textarea
                id="employer-message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="6"
                placeholder={t.messagePh}
                className={`w-full border border-line rounded-sm px-4 py-2 focus:ring-2 focus:ring-royal/40 focus:border-royal outline-none transition bg-white font-medium text-ink ${errors.message ? 'border-red-400' : ''}`}
              />
              {errors.message && <p className="text-red-500 text-xs mt-1 font-medium">{errors.message}</p>}
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full px-6 py-3 rounded-sm font-bold transition-colors duration-300 text-lg tracking-wide ${loading ? "bg-platinum text-steel/60 cursor-not-allowed" : "bg-navy hover:bg-ink text-white"}`}
            >
              {loading ? t.submitting : t.submit}
            </button>

            {successMessage.type && (
              <div className="mt-4 text-center text-green-700 bg-green-50 border border-green-300 px-4 py-2 rounded-md font-semibold shadow-sm animate-fade-in">
                {successMessage.text}
              </div>
            )}

            {failureMessage.type && (
              <div className="mt-4 text-center text-red-700 bg-red-50 border border-red-300 px-4 py-2 rounded-md font-semibold shadow-sm animate-fade-in">
                {failureMessage.text}
              </div>
            )}
          </form>
        </div>
      </section>
    </HRLayout>
  );
}
